<template>
    <div class="page bg-gray pb-fixed-btn">
        <backTitleBar></backTitleBar>
        <div class="shop-register-state">
            <div class="text color-main">基本信息</div>
            <div class="alifont icon-jianjinlv color-main"></div>
            <div class="text color-999">公司信息</div>
            <div class="alifont icon-jianjinhei color-999"></div>
            <div class="text color-999">店铺设置</div>
        </div>
        <div class="content pd-025">
            <div class="card mt-20">
                <div class="pd-020">
                    <div class="input-field">
                        <div class="fs-32 color-333 left">客户经理<br/>名字</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.referrer" placeholder="请输入客户经理名字" />

                    </div>
                </div>
            </div>
            <div class="card mt-20">
                <div class="pd-020">
                    <div class="input-field bd-bot click" @click="showCategoryPop = true">
                        <div class="fs-32 color-333 left required">主营类目 </div>
                        <div class="field-content" :class="formItem.businessTypeName ? 'color-333':'color-999'">{{formItem.businessTypeName || '请选择主营类目'}}</div>
                        <div class="alifont icon-fanhui1 fs-30 color-999 right"></div>
                    </div>
                    <div class="input-field">
                        <div class="fs-32 color-333 left required">营业时间</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.businessTime" placeholder="请输入营业时间" />

                    </div>
                </div>
            </div>
            <div class="card mt-20">
                <div class="pd-020">
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">门店名称</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.shopName" placeholder="请输入门店名称" />
                    </div>
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">服务电话</div>
                        <van-field class="input" type="tel" :clearable="true" v-model="formItem.serviceTel" placeholder="请输入服务电话" />
                    </div>
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">负责人</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.linkor" placeholder="请输入负责人" />
                    </div>
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">负责人电话</div>
                        <van-field class="input" type="tel" :clearable="true" v-model="formItem.linkTelephone" placeholder="请输入负责人电话" />
                    </div>
                    <div class="input-field bd-bot click" @click="$refs.pickerArea.popupShow = true">
                        <div class="fs-32 color-333 left required">所在地区 </div>
                        <div class="field-content" :class="formItem.areaname ? 'color-333':'color-999'">{{formItem.areaname.split(",").join(" ") || '请选择所在地区'}}</div>
                        <div class="alifont icon-fanhui1 fs-30 color-999 right"></div>
                    </div>
                    <div class="input-field bd-bot click" @click="$refs.chooseMap.popupShow = true">
                        <div class="fs-32 color-333 left required">经纬度</div>
                        <div class="field-content color-333" v-show="formItem.lng && formItem.lat">{{formItem.lng + ' , ' +  formItem.lat}}</div>
                        <div class="field-content color-999" v-show="!(formItem.lng && formItem.lat)">请选择所在经纬度</div>
                        <div class="alifont icon-fanhui1 fs-30 color-999 right"></div>
                    </div>
                    <div class="input-field" style="align-items: baseline">
                        <div class="fs-32 color-333 left required">详细地址</div>
                        <van-field class="input" type="textarea" autosize :clearable="true" v-model="formItem.address" placeholder="请输入详细地址" />
                    </div>
                </div>
            </div>
        </div>
        <div class="fixed-bot">
            <div class="btn click" @click="submitForm()">下一步</div>
        </div>


        <pickerArea ref="pickerArea" @change="areaConfirm"></pickerArea>

        <chooseMap ref="chooseMap" :lng="Number(formItem.lng)" :lat="Number(formItem.lat)" @sure="mapConfirm"></chooseMap>

        <van-popup v-model="showCategoryPop" position="bottom">
            <van-picker show-toolbar :columns="columns" value-key="categoryName"  @cancel="showCategoryPop = false" @change="onChange" @confirm="onConfirm"  />
        </van-popup>


    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import {getCategory} from "@/api/base"
    import {listConvertTree} from "@/utils/util"
    import pickerArea from "@/components/picker-area/index"
    import {qryShopDetail} from "@/api/shop"
    import chooseMap from "../chooseAddress"
    import getAppParams from "@/mixins/getAppParams"
    import inputFix from "@/mixins/inputBugFix"
    export default {
        name: "baseInfo",
        components:{backTitleBar,pickerArea,chooseMap},
        mixins:[getAppParams,inputFix],
        data(){
            return{
                showCategoryPop:false,
                popupShow:false,
                columns:[],
                formItem:{
                    areaname:'',
                },
                businessType:'offlineShopType',
                shopId:this.$store.state.user.shopId,
                registerInfo:JSON.parse(localStorage.getItem('registerInfo')) || {},
            }
        },
        created() {
            // this.getCategory();
            this.getDetail();
        },
        methods:{
            //获取商家详情
            getDetail(){
                qryShopDetail(this.shopId).then(res=>{
                    res.data.clearingCycle = String(res.data.clearingCycle)
                    this.formItem = res.data;
                    this.formItem = Object.assign({}, this.formItem, this.registerInfo,{shopId:this.shopId} );
                    if(res.data.businessState == 1){
                        this.checked = true;
                    }else{
                        this.checked = false;
                    }
                    if(this.formItem.shopType == 3){
                        this.businessType = 'offlineShopType'
                    }else if(this.formItem.shopType == 4){
                        this.businessType = 'onlineShopType'
                    }
                    this.getCategory();
                })
            },
            //确定选择省市区
            areaConfirm(e){
                this.formItem.areaname = e.map(item=>{
                    return item.areaname
                }).join(",")
                this.formItem.provinceId = e[0].areacode;
                this.formItem.cityId = e[1].areacode;
                this.formItem.countyId = e[2].areacode;
            },
            mapConfirm(data){
                this.formItem.lng = data.lng;
                this.formItem.lat = data.lat;
                if(data.address){
                    this.formItem.address = data.address;
                }
            },
            //获取分类
            getCategory () {
                getCategory({businessType: this.businessType}).then(res => {
                    let opt = {
                        primaryKey: 'categoryId',
                        parentKey: 'parentId',
                        startPid: '-1'
                    }
                    let data = listConvertTree(res.data, opt)
                    this.setSelectTree(data)
                })
            },
            setSelectTree (data) {
                let categoryList = data;
                this.columns = [
                    {
                        values: categoryList,  // 设置的页面初始值
                        className: "column1"
                    },
                    {
                        values: categoryList[0].children,
                        className: "column2"
                    },
                ]
            },
            //选中分类
            onConfirm(value){
                if(value[value.length - 1]){
                    this.$set(this.formItem,'businessType',value[value.length -1].categoryId);
                    this.$set(this.formItem,'businessTypeName',value[value.length -1].categoryName);
                }else{
                    this.$set(this.formItem,'businessType',value[value.length -2].categoryId);
                    this.$set(this.formItem,'businessTypeName',value[value.length -2].categoryName);
                }

                this.showCategoryPop = false;
            },
            onChange(picker, values, index) {
                picker.setColumnValues(index + 1, values[index ].children || []); //点当前列更新下一列数据，防止undefined
            },


            submitForm(){
                let form = this.formItem
                if(!form.shopName || !form.businessType || !form.serviceTel || !form.linkor || !form.linkTelephone || !form.address || !form.areaname || !form.businessTime || !form.lng || !form.lat){
                    this.$toast("请填写必填项目");
                    return
                }
                let params = {
                    shopName: form.shopName,
                    businessType: form.businessType,
                    businessTypeName:form.businessTypeName,
                    serviceTel: form.serviceTel,
                    linkor: form.linkor,
                    linkTelephone: form.linkTelephone,
                    address: form.address,
                    businessTime: form.businessTime,
                    areaname: form.areaname,
                    provinceId: form.provinceId,
                    cityId: form.cityId,
                    countyId: form.countyId,
                    lng:form.lng,
                    lat: form.lat,
                    referrer:form.referrer|| '',
                    shopType: form.shopType,
                    shopId: form.shopId
                }
                this.registerInfo = Object.assign({}, this.formItem, params);
                localStorage.setItem('registerInfo', JSON.stringify(this.registerInfo));
                this.$router.push({name: 'shopRegisterCompanyInfo'});
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// baseInfo.vue?0a20b7cb